import { render, staticRenderFns } from "./SightingsInfo.vue?vue&type=template&id=4461a24f&scoped=true&"
import script from "./SightingsInfo.vue?vue&type=script&lang=js&"
export * from "./SightingsInfo.vue?vue&type=script&lang=js&"
import style0 from "./SightingsInfo.vue?vue&type=style&index=0&id=4461a24f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461a24f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VFlex,VImg,VLayout,VProgressCircular,VRow})
